import type { Event } from "@apps/gwservice/types"
import { buildEventIcs } from "./build-ics"

const deepLinkFor = (event: Event): string => {
  const base = typeof window !== "undefined" ? window.location.origin : ""
  return `${base}/?tab=calendar&eventId=${event.id}`
}

export const shareEvent = (event: Event): void => {
  const ics = buildEventIcs(event, deepLinkFor(event))
  const a = document.createElement("a")
  a.href = `data:text/calendar;charset=utf-8,${encodeURIComponent(ics)}`
  a.download = `event-${event.id}.ics`
  a.click()
}
